import * as API from '@/api/index'

/* 登录 */
export const loginPost = (params) => {
  return API.POST('/A04LoginController/selectUserInfo', params);
}

/* 注册 */
export const userRegistration = (params) => {
  return API.POST('/A10UserManagement/userRegistration', params);
}

/* 查 - 项目列表 */
export const selectProjectList = (params) => {
  return API.POST('/A10UserManagement/selectProjectList', params);
}

/* 根据项目查 - 角色列表 */
export const selectRoleList = (params) => {
  return API.POST('/A10UserManagement/selectRoleList', params);
}

/* 微信列表 */
export const findWeChatInfo = (params) => {
  return API.POST('/A10UserManagement/findWeChatInfo', params);
}